<div class="cfa-hamburger-menu-backdrop d-lg-none" *ngIf="expandHamburgerMenu" [@menuBackdropState]="'active'"></div>
<div #hamburgerMenu class="container pt-4 pb-4 cfa-hamburger-menu d-lg-none"
     [class.mat-app-background]="useMaterialTheme" [class.cfaCustomLightTheme]="!useMaterialTheme"
     [@menuState]="expandHamburgerMenu? 'active' : 'inactive'">
    <div class="row mb-3" (click)="clickHome()" id="hamburgerHome">
        <div class="col cfa-18 clicky">
            HOME
        </div>
    </div>
    <ng-container *ngFor="let tab of cfaTabs; let i = index;">
        <div class="row mb-3" (click)="selectTab($event, tab, true)" id="tab{{i}}" [class.disabled]="tab.disabled">
            <div class="col-auto cfa-menu-tab-label align-self-center cfa-18 clicky pr-0"
                 [class.activeTab]="tab.active">
                {{tab.label}}
            </div>
            <div class="col-auto cfa-15 align-self-center text-center pl-0 pr-0">
                <svg-icon class="cfa-tab-icon" *ngIf="tab.childTabs && tab.childTabs.length > 0"
                          src="https://d4gii57lvoht3.cloudfront.net/images/Arrow_Down.svg"></svg-icon>
            </div>
        </div>
        <div *ngIf="tab.childTabs && tab.childTabs.length > 0 && tab.expanded" class="childTabList"
             [@openChildTabState]="'active'">
            <div class="row cfa-child-nav-tab mb-3 w-100 m-0" *ngFor="let cTab of tab.childTabs; let j = index;"
                 [class.active]="cTab.active" [class.disabled]="tab.disabled || cTab.disabled"
                 (click)="selectTab($event, cTab)" id="cTab{{j}}">
                <div class="col-12 align-self-center cfa-15 text-left">
                    {{cTab.label}}
                </div>
            </div>
        </div>
    </ng-container>
    <hr class="mb-4 mt-4" *ngIf="cfaTabs.length > 0">
    <div class="row mb-3" *ngFor="let menuItem of cfaMenuItems; let i = index;" (click)="selectMenuItem(menuItem)"
         id="menuItem{{i}}" [class.disabled]="menuItem.disabled">
        <div class="col" [class.cfa-14]="menuItem.textOnly" [class.cfa-18]="!menuItem.textOnly"
             [class.clicky]="!menuItem.textOnly">
            {{menuItem.label}}
        </div>
    </div>
    <hr class="mb-4 mt-4" *ngIf="cfaMenuItems.length > 0">
    <div class="row mb-3" *ngIf="userName">
        <div class="col cfa-14">
            {{userName}}
        </div>
    </div>
    <div class="row" *ngIf="userName">
        <div class="col cfa-18 activeTab clicky" (click)="clickSignOut()" id="signOut-button">
            Sign Out
        </div>
    </div>
</div>
